import styled from "styled-components";
const MessageContentStyle = styled.div`
  padding: 15px ${({
  showCloseIcon
}) => showCloseIcon ? "50px" : "20px"} 15px
    ${({
  reduceLeftPadding
}) => reduceLeftPadding ? "10px" : "20px"};
  white-space: pre-wrap;
  flex: 1;
`;
export default MessageContentStyle;